import React from "react";
import { Typography, FormControlLabel, Checkbox } from "@mui/material";

function FilterCheckbox(props: any) {
  const {
    keyVal,
    checked,
    checkboxFunction,
    label,
    countColor,
    filterCount,
    showResultCount = false,
    isBatchCompleted = false,
  } = props;
  return (
    <>
      <FormControlLabel
        key={keyVal}
        control={
          <Checkbox
            sx={{
              strokeWidth: 1,
              color: "#D0D5DD",
              // zIndex: "999999",
              "&:hover": {
                backgroundColor: "transparent",
              },
              "&:focus": {
                backgroundColor: "transparent",
              },
            }}
            checked={checked}
            onChange={checkboxFunction}
          />
        }
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          "& .MuiFormControlLabel-label": {
            flex: 1,
          },
        }}
        label={
          // <Typography
          //   style={{
          //     fontSize: "14px",
          //     fontWeight: "400",
          //     color: "#667085",
          //     lineHeight: "20px",
          //     textTransform: "capitalize",
          //   }}
          // >
          //   {label}
          // </Typography>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "5px",
              color: isBatchCompleted === true ? "red" : "#667085",
              fontSize: "13px",
              textTransform: "capitalize",
            }}
          >
            <div> {label}</div>
            {showResultCount && (
              <div
                style={{
                  color: countColor ? countColor : "#667085",
                  fontWeight: "600",
                  marginRight: "5px",
                }}
              >
                {filterCount}
              </div>
            )}
          </div>
        }
      />
    </>
  );
}

export default FilterCheckbox;
